import { createStore } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";






//import { userModule } from "./userData/user.module"; NEW
import { userModule } from "./user.module";



import { orderModule } from "./order.module";
import { ordersBackListModule } from "./ordersBackList.module";
import { productsModule } from "./products.module";

import { purchaseModule } from "./purchase.module";
import { shipmentModule } from "./shipment.module";

import { paisModule } from "./pais.module";
import { courierModule } from "./courier.module";
import { courierServiceModule } from "./courierService.module";
import { courierShippingMethodModule } from "./courierShippingMethod.module";
import { orderTypeModule } from "./orderType.module";

import { dashboardModule } from "./dashboard.module";
import { dashboardOverviewModule } from "./dashboardOverview.module";

import { manifiestModule } from "./manifest.module";
import { customerModule } from "./administration/customer.module";
import { administrationModule } from "./administration/administration.module";
import { packageModule} from "./administration/package.module";
import { queueModule} from "./administration/queue.module";
import { dashboardAdminModule} from "./administration/dashboardAdmin.module";









import { brandAdminModule } from "./administration/brand/brand.admin.module";

import { integrationsAlierSGAOrderOutboxQueueAdminModule } from "./administration/integrations/alierSGA/order.outbox.queue.admin.module";
import { integrationsAlierSGAOrderBackOutboxQueueAdminModule } from "./administration/integrations/alierSGA/orderback.outbox.queue.admin.module";
import { integrationsAlierSGAProductOutboxQueueAdminModule } from "./administration/integrations/alierSGA/product.outbox.queue.admin.module";
import { integrationsAlierSGAPurchaseOutboxQueueAdminModule } from "./administration/integrations/alierSGA/purchase.outbox.queue.admin.module";

import { usersAdminModule } from "./administration/users/users.admin.module";



import { importModule } from "./customer/import/import.module";

import { stockModule } from "./customer/warehouse/stock.module";
import { warehouseModule } from "./customer/warehouse/warehouse.module";



export default createStore({
  modules: {
    
    user: userModule,
    
    
    
    
    
    
    
    ordersBackList: ordersBackListModule,
    order: orderModule,
    products: productsModule,
    
    purchase: purchaseModule,
    shipment: shipmentModule,
    
    paises: paisModule,
    couriers: courierModule,
    courierServices: courierServiceModule,
    courierShippingMethods: courierShippingMethodModule,
    orderTypes: orderTypeModule,

    dashboard: dashboardModule,
    dashboardOverview: dashboardOverviewModule,
    
    manifiest: manifiestModule,
    customer: customerModule,
    administration: administrationModule,
    package: packageModule,
    queue: queueModule,
    dashboardAdmin:dashboardAdminModule,





    brandAdmin: brandAdminModule,




    integrationsAlierSGAOrderOutboxQueueAdmin: integrationsAlierSGAOrderOutboxQueueAdminModule,
    integrationsAlierSGAOrderBackOutboxQueueAdmin: integrationsAlierSGAOrderBackOutboxQueueAdminModule,
    integrationsAlierSGAProductOutboxQueueAdmin: integrationsAlierSGAProductOutboxQueueAdminModule,
    integrationsAlierSGAPurchaseOutboxQueueAdmin: integrationsAlierSGAPurchaseOutboxQueueAdminModule,

    
    usersAdmin: usersAdminModule,

    import: importModule,

    stock: stockModule,
    warehouse: warehouseModule,
  },
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    isTransparent: false,
    isRTL: false,
    color: "",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    navbarFixed: "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
    bootstrap
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.isTransparent = payload;
    },
    cardBackground(state, payload) {
      state.color = payload;
    },
    navbarFixed(state) {
      state.isNavFixed = !state.isNavFixed;
    },
    toggleEveryDisplay(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
      state.showConfig = !state.showConfig;
    },
    toggleHideConfig(state) {
      state.hideConfigButton = !state.hideConfigButton;
    }
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    setCardBackground({ commit }, payload) {
      commit("cardBackground", payload);
    },
  },
  getters: {}
});